import {
  Button,
  CircularProgress,
  Grid2,
  styled,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";

import theme from "../../theme";
import TitleBar from "../common-components/TitleBar";
import {
  StyledContainer,
  StyledListContainer,
  StyledListItem,
  StyledListItemContent,
  StyledListItemText,
  StyledTitle,
} from "../style/ititn/DeatilStyle";
import { useNavigate, useParams } from "react-router-dom";
import {
  DocumentUploadIcon,
  PreviewIcon,
} from "../../assets/Icon/dashboredIcon";
import UploadSignComponent from "../itin/w2484form/UploadSignComonent";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import img1 from "../../assets/Images/image1.png";
import img2 from "../../assets/Images/image2.png";
import img4 from "../../assets/Images/image4.png";
import img5 from "../../assets/Images/image5.png";
import img3 from "../../assets/Images/imagePassport.png";
import SS4Form from "../../pages/IntechTechnology/SS4Form";
import { getIncorporationList, getUrl } from "../../stores/incorporation";

import { EditIconTable } from "../../assets/Icon/ArrowIcon";
import { NoteIcon } from "../../assets/Icon/LlcForm";
import MessageBox from "../../pages/orders/MessageBox";
import MessageEditor from "../../pages/orders/MessageEditor";
import { StyledGridBox } from "../../pages/orders/OrderDetails";
import { useAppDispatch } from "../../stores/store";
import ListLoadingNew from "../common-components/ListLoadingNew";
import NoDataFound from "../common-components/NoDataFound";
import PreviewModal from "../itin/PreviewModal";

import useDownloader from "react-use-downloader";
import {
  MessaageArrowUpIcon,
  MessaageRightIcon,
} from "../../assets/Icon/OrderDetailIcon";
import {
  getMessageData,
  handleSendMessage,
  setMessage,
  setNewMessage,
} from "../../stores/orders";
import { localName } from "../../utils/StorageUtils";
import BackPageButton from "../common-components/BackPageButton";
import { setToast } from "../../stores/toast/toastslice";

interface StepProp {}
interface ListItemData {
  img: string;
  text: string;
  key: string;
}

interface DocItem {
  previewImage: any;
  title: string;
  docId: string;
  attribute: string;
}

const listData: ListItemData[] = [
  { img: img1, text: "Business Incorporation", key: "business_incorporation" },
  { img: img2, text: "EIN Document", key: "ein_document" },
  { img: img3, text: "Scanned Passport", key: "scan_passport" },
  { img: img4, text: "W-7 Form", key: "w7_form" },
  { img: img5, text: "2848 Form", key: "form_2848" },
  { img: img4, text: "W -7 Form with Signature", key: "w7_signed_form" },
  { img: img5, text: "2848 Form With Signature", key: "form_2848_signed_form" },
  { img: img5, text: "SS4 Form Signature", key: "signed_ein_form" },
  { img: img5, text: "SS4 Form ", key: "ein_form_file" },
  { img: img5, text: "LLC Form ", key: "llc_form" },
  { img: img5, text: "LLC Application Form", key: "status" },
  // { img: img5, text: "EIN Document", key: "ss4_verified_documents" },
  // { img: img5, text: "Verified Form File", key: "llc_document_file" },
];

const LlcDetail = () => {
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const [openPreview, setOpenPreview] = useState(false);
  const [edit, setEdit] = useState(false);
  const [sentMessage, setSentMessage] = useState<string[]>([]);
  const [documents, setDocuments] = useState<DocItem[]>([]);
  const [selectedFiles, setSelectedFiles] = useState<
    { file: File; preview: string }[]
  >([]);
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const navigate = useNavigate();
  const [img, setImg] = useState("");
  const [downloadingFile, setDownloadingFile] = useState<string | null>(null);
  const [isMessageBox, setIsMessageBox] = useState<boolean>(false);
  const [showMessageContent, setShowMessageContent] = useState<boolean>(false);
  const messageEndRef = useRef<HTMLDivElement | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isMessageLoading, setIsMessageLoading] = useState(true);
  const { incorporationDetails, status, length } = useSelector(
    (store: any) => store.incorporation,
  );
  const { download } = useDownloader();
  const {
    fetchMessgaeData,
    typeMessage,
    messageDetails,
    // userIds,
  } = useSelector((state: any) => state.orders);
  const selectedCard = localStorage.getItem("selectedCard") || "company";
  const baseUrl = process.env.REACT_APP_BASE_IMAGE_URL || "";
  const { id } = useParams<{ id: string }>();
  const FetchList = async () => {
    const response = await dispatch<any>(
      getIncorporationList({ order_id: id }),
    );
    if (response?.payload?.status >= 400) {
      dispatch<any>(
        setToast({
          message: response?.payload?.data?.detail || "Something went wrong!",
          type: "error",
          title: "Error",
        }),
      );
      navigate("/incorporation");
      return;
    }
  };
  useEffect(() => {
    FetchList();
  }, []);
  useEffect(() => {
    // FetchList();
    if (incorporationDetails?.user_id) {
      getMessage();
    }
  }, [incorporationDetails?.user_id]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 3000);

    return () => clearTimeout(timeout);
  }, []);

  const hasVerifiedSS4Forms =
    Array.isArray(incorporationDetails["ss4_verified_documents"]) &&
    incorporationDetails["ss4_verified_documents"].length > 0;

  useEffect(() => {
    // FetchList();
    if (incorporationDetails) {
      const docs: DocItem[] = listData
        .filter((item) => incorporationDetails[item.key])
        .map((li) => ({
          attribute: li.key,
          docId: incorporationDetails[li.key],
          previewImage: li.img,
          title: li.text,
        }));
      if (incorporationDetails.llc_document_file) {
        docs.push({
          previewImage: img5,
          title:
            incorporationDetails.llc_verified_documents.length > 0
              ? `Company Formation Document 1`
              : `Company Formation Document`,
          attribute: `llc_document_file`,
          docId: incorporationDetails.llc_document_file,
        });
      }
      if (incorporationDetails.llc_verified_documents) {
        docs.push(
          ...incorporationDetails.llc_verified_documents.map(
            (item: any, idx: number) => ({
              previewImage: img5,
              title:
                incorporationDetails.llc_verified_documents > 1
                  ? `Company Formation Document ${idx + 3}`
                  : `Company Formation Document ${idx + 2}`,
              attribute: `llc_verified_documents`,
              docId: item,
            }),
          ),
        );
      }
      setDocuments(docs);
    }
  }, [incorporationDetails]);

  const handleClose = () => {
    setOpenPreview(false);
  };
  useEffect(() => {
    if (showMessageContent && messageEndRef.current) {
      messageEndRef.current.scrollIntoView({ behavior: "smooth" });
      document.getElementById("messgeContent")?.scrollTo({
        top: document.getElementById("messgeContent")?.scrollHeight,
        behavior: "smooth", // optional, for smooth scrolling
      });
    }
  }, [showMessageContent, isMessageBox, fetchMessgaeData]);

  const handleEdit = (key: string) => {
    if (key === "ein_form_file") {
      navigate(`/incorporation-detail/${id}/ss4/edit`);
      setOpen(true);
    } else if (key === "signed_ein_form") {
      setEdit(true);
    } else {
      setTimeout(() => {
        navigate(`/incorporation/${id}/edit`);
      }, 300);
    }
  };
  if (open) {
    return <SS4Form handleClose={() => setOpen(false)} />;
  }

  const handleDownload = async (
    fileUrl: string,
    fileName: string = "document.pdf",
  ) => {
    try {
      setDownloadingFile(fileUrl);
      // download(fileUrl, fileName);
      const response = await fetch(fileUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/octet-stream",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch file");
      }

      const reader = response.body?.getReader();
      if (!reader) {
        throw new Error("Failed to get stream reader");
      }

      const stream = new ReadableStream({
        async start(controller) {
          while (true) {
            const result = await reader.read();
            if (result.done) break;
            controller.enqueue(result.value);
          }
          controller.close();
          reader.releaseLock();
        },
      });

      const blob = await new Response(stream).blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      window.open(fileUrl, "_blank");
    } finally {
      setDownloadingFile(null);
    }
  };

  const sendMessage = async () => {
    setSending(true);
    const newMessage = typeMessage
      .replace(/<p><br\s*\/?><\/p>/gi, "")
      .replace(/<[^>]*>/g, "")
      .replace(/\s+/g, " ")
      .trim();

    if (!newMessage && selectedFiles.length === 0) {
      return;
    }
    try {
      const formData = new FormData();
      formData.append("message", typeMessage || ""); // assuming message is a state variable

      selectedFiles.forEach((fileObj: any, index: number) => {
        formData.append("files", fileObj.file); // or just "attachments"
      });
      const newdata = {
        message: typeMessage,
        sender_name: localName,
        files: selectedFiles.map((fileObj: any) => fileObj.file),
      };
      dispatch<any>(setNewMessage(newdata));
      const result = await dispatch<any>(
        handleSendMessage({
          user_id: Number(incorporationDetails.user_id),
          order_id: id,
          formData,
        }),
      );
      setSentMessage((prev) => [...prev, typeMessage]);

      // getMessage(false);
      dispatch<any>(setMessage(""));
      setSelectedFiles([]);

      setSentMessage([]);
      // setSupportId(result.payload.data.id);
      // if (result.payload.status == 1) {
      //   setIsMessageBox(true);
      // }
    } catch (error) {
      // Optional: show error toast or handle error
    } finally {
      setSending(false);
    }
  };
  const getMessage = async (showLoader: boolean = true) => {
    if (showLoader) {
      setIsMessageLoading(true);
    }

    try {
      const result = await dispatch<any>(
        getMessageData({ user_id: incorporationDetails.user_id, order_id: id }),
      );
      if (showLoader) {
        setIsMessageLoading(false);
      }
      // setSupportId(result.payload.data.id);
    } catch (error) {
      // Optional: show error toast or handle error
      if (showLoader) {
        setIsMessageLoading(true);
      }
    }
  };

  const handleDownloadUrl = async (url: string) => {
    try {
      setDownloadingFile(url);
      const response = await dispatch<any>(getUrl({ url: url }));
      const fileUrl = response?.payload?.data;
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = fileUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      setDownloadingFile(null);
    } finally {
      setDownloadingFile(null);
    }
  };

  const sendMessage1 = async () => {
    const newMessage = typeMessage
      .replace(/<p><br\s*\/?><\/p>/gi, "")
      .replace(/<[^>]*>/g, "")
      .replace(/\s+/g, " ")
      .trim();

    if (!newMessage && selectedFiles.length === 0) {
      return;
    }

    try {
      const formData = new FormData();
      formData.append("message", typeMessage || ""); // assuming message is a state variable

      selectedFiles.forEach((fileObj: any) => {
        formData.append("files", fileObj.file); // or just "attachments"
      });

      // Prepare message data for dispatch
      const newdata = {
        message: typeMessage,
        sender_name: localName,
        files: selectedFiles.map((fileObj: any) => fileObj.file),
      };

      // Dispatch new message action
      dispatch<any>(setNewMessage(newdata));

      const result = await dispatch<any>(
        handleSendMessage({
          user_id: Number(incorporationDetails.user_id),
          order_id: id,
          formData,
        }),
      ); // Correct closing parenthesis

      // Add the new message to fetchMessgaeData
      dispatch<any>(
        getMessageData({ user_id: incorporationDetails.user_id, order_id: id }),
      );

      // Clear message input and selected files
      dispatch<any>(setMessage(""));
      setSelectedFiles([]);
      setSentMessage([]);
    } catch (error) {}
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <CircularProgress />
        </div>
      </div>
    );
  }

  return (
    <Box>
      <BackPageButton />
      <TitleBar title={"LLC+EIN Details"} />
      {!incorporationDetails ? (
        <ListLoadingNew />
      ) : (listData.length === 0 || incorporationDetails.length === 0) &&
        !isLoading ? (
        <NoDataFound
          title={
            selectedCard === "ein" ? "EIN Data Not Found" : "LLC Data Not Found"
          }
          subTitle={` You haven't added any ${
            selectedCard === "ein" ? "EIN " : "LLC "
          } details yet, so no data is available. Please
              update your information to view the details.`}
          status={true}
        />
      ) : (
        <StyledContainer>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              padding: 1,
              flexWrap: "wrap",
            }}
          >
            <StyledTitle>Uploaded Documents</StyledTitle>
            {incorporationDetails?.status === 3 && (
              <Button
                variant="contained"
                sx={{ width: "120px", whiteSpace: "nowrap" }}
                onClick={() => navigate(`/incorporation-detail/${id}/ss4`)}
              >
                Apply for EIN
              </Button>
            )}
          </Box>

          <StyledListContainer>
            {documents.map((item, index) => (
              <StyledListItem key={index}>
                <StyledListItemContent>
                  <StyledListItemText>
                    <img
                      key={item.attribute}
                      src={item.previewImage}
                      // src={ item.key === "scan_passport" ? `${baseUrl}${incorporationDetails[item.key]}` : item.img}

                      alt={item.title}
                      style={{
                        objectFit: "cover",
                        height: "37px",
                        width: "40px",
                      }}
                    />
                    <Typography
                      variant="h5"
                      sx={{ color: theme.palette.myCustomColor.dark }}
                    >
                      {item.title}
                    </Typography>
                  </StyledListItemText>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      cursor: "pointer",
                    }}
                  >
                    {(item.attribute === "signed_ein_form" ||
                      item.attribute === "ein_form_file") &&
                      incorporationDetails?.status <= 5 && (
                        <span onClick={() => handleEdit(item.attribute)}>
                          <EditIconTable />
                        </span>
                      )}

                    {item.attribute === "status" &&
                      Number(incorporationDetails?.status) === 1 && (
                        <span onClick={() => handleEdit(item.attribute)}>
                          <EditIconTable />
                        </span>
                      )}

                    <span
                      onClick={() => {
                        if (item.attribute === "status") {
                          navigate(`/incorporation/${id}/view`);
                        } else {
                          setOpenPreview(true);
                          setImg(`${baseUrl}${item.docId}`);
                          // setImg(`${incorporationDetails[item.key]}`);
                        }
                      }}
                    >
                      <PreviewIcon />
                    </span>
                    {item?.title != "LLC Application Form" && (
                      <span onClick={() => handleDownloadUrl(item.docId)}>
                        {downloadingFile ===
                        incorporationDetails[item?.attribute] ? (
                          <>
                            <CircularProgress
                              sx={{
                                width: "31px !important",
                                height: "30px !important",
                              }}
                            />
                          </>
                        ) : (
                          <DocumentUploadIcon />
                        )}
                      </span>

                      // <span
                      //   onClick={(e) => {

                      //     e.preventDefault();
                      //     const fileUrl = `${baseUrl}${
                      //       incorporationDetails[item.key] ?? ""
                      //     }`;

                      //     const fileName = item.text;

                      //     const fileExtension = fileUrl
                      //       .split(".")
                      //       .pop()
                      //       ?.toLowerCase();
                      //     const finalFileName =
                      //       fileExtension && !fileName.endsWith(fileExtension)
                      //         ? `${fileName}.${fileExtension}`
                      //         : fileName;

                      //     handleDownload(fileUrl, finalFileName);
                      //   }}
                      // >
                      //   {downloadingFile ===
                      //   incorporationDetails[item.key] ? (
                      //     <>
                      //       <CircularProgress
                      //         sx={{
                      //           width: "31px !important",
                      //           height: "30px !important",
                      //         }}
                      //       />
                      //     </>
                      //   ) : (
                      //     <DocumentUploadIcon />
                      //   )}
                      // </span>
                    )}
                  </Box>
                </StyledListItemContent>
              </StyledListItem>
            ))}

            {hasVerifiedSS4Forms && (
              <>
                <StyledListItem>
                  <StyledListItemContent>
                    <StyledListItemText>
                      <img
                        src={img5}
                        alt={""}
                        style={{
                          objectFit: "cover",
                          height: "37px",
                          width: "40px",
                        }}
                      />
                      <Typography
                        variant="h5"
                        sx={{ color: theme.palette.myCustomColor.dark }}
                      >
                        EIN Document
                      </Typography>
                    </StyledListItemText>

                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        cursor: "pointer",
                      }}
                    >
                      <span
                        onClick={() => {
                          setOpenPreview(true);
                          setImg(
                            `${baseUrl}${incorporationDetails?.ss4_verified_documents[0]}`,
                          );
                          // setImg(`${incorporationDetails[item.key]}`);
                        }}
                      >
                        <PreviewIcon />
                      </span>

                      <span
                        onClick={() =>
                          handleDownloadUrl(
                            incorporationDetails?.ss4_verified_documents[0],
                          )
                        }
                      >
                        {downloadingFile ===
                        incorporationDetails[
                          incorporationDetails?.ss4_verified_documents[0]
                        ] ? (
                          <>
                            <CircularProgress
                              sx={{
                                width: "31px !important",
                                height: "30px !important",
                              }}
                            />
                          </>
                        ) : (
                          <DocumentUploadIcon />
                        )}
                      </span>
                    </Box>
                  </StyledListItemContent>
                </StyledListItem>
              </>
            )}
          </StyledListContainer>
        </StyledContainer>
      )}

      <PreviewModal open={openPreview} handleClose={handleClose} img={img} />

      {/***************   Details second Components ******************************************/}
      {((incorporationDetails?.signed_ein_form === null &&
        incorporationDetails?.ein_form_file != null) ||
        edit) && (
        <UploadSignComponent
          formTitle={"SS-4  Form"}
          id={incorporationDetails?.id}
          uploadedFile={edit ? incorporationDetails?.signed_ein_form : null}
          edit={edit}
          onCancelEdit={() => setEdit(false)}
          onSuccess={() =>
            dispatch<any>(getIncorporationList({ order_id: id }))
          }
        />
      )}

      {incorporationDetails?.status <= 2 && (
        <StyledNoteBox>
          <NoteIcon />
          <StyledNoteText>
            Note:{" "}
            <StyledNoteSpan>
              Once the company formation is done, you will see your document
              here.
            </StyledNoteSpan>
          </StyledNoteText>
        </StyledNoteBox>
      )}
      <Grid2 container spacing={2} sx={{ marginTop: 2 }}>
        <StyledGridBox
          size={{ xs: 12, md: 12 }}
          sx={{
            // border: "2px solid #EAF1FA",
            borderRadius: "12px",
            background: "#ffff",
            boxShadow: `
      0px 1px 2px 0px #00000005,
      0px 3px 3px 0px #00000005,
      0px 7px 4px 0px #00000003,
      0px 12px 5px 0px #00000000,
      0px 18px 5px 0px #00000000
    `,
            border: "none !important",
          }}
        >
          <Box
            sx={{
              padding: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              cursor: "pointer",
            }}
            onClick={() => setShowMessageContent(!showMessageContent)}
          >
            <Typography
              variant="subtitle1"
              sx={{
                color: "#2977CC",
                fontWeight: 600,
                fontSize: "22px",
                borderBottom: "2px solid #2977CC",
                display: "inline-block",
                pb: 0.5,
                marginX: 2,
              }}
            >
              Message
            </Typography>
            <Box
              // onClick={() => setShowMessageContent(!showMessageContent)}
              sx={{ cursor: "pointer" }}
            >
              {!showMessageContent && <MessaageRightIcon />}
              {showMessageContent && <MessaageArrowUpIcon />}
            </Box>
          </Box>

          {showMessageContent &&
            (isMessageLoading ? (
              <ListLoadingNew />
            ) : fetchMessgaeData.length === 0 &&
              !isMessageLoading &&
              !isMessageBox ? (
              <Grid2 size={{ xs: 12, md: 12 }} ref={messageEndRef}>
                <NoDataFound
                  isMessage={true}
                  title="No Conversation Yet"
                  subTitle="No conversation has been initiated yet. Once a message is sent or received, the conversation history will appear here."
                  handleData={() => {
                    getMessage(false);
                    setIsMessageBox(true);
                  }}
                  status={true}
                />
              </Grid2>
            ) : (
              <Box ref={messageEndRef}>
                <MessageBox
                  fetchMessgaeData={fetchMessgaeData}
                  isPadding={true}
                  sentData={messageDetails}
                  sending={sending}
                />
                {/* <div ref={messageEndRef} /> */}

                {isMessageBox ? (
                  <Box sx={{ padding: 3 }} ref={messageEndRef}>
                    <MessageEditor
                      handleSend={() => {
                        sendMessage();
                      }}
                      selectedFiles={selectedFiles}
                      setSelectedFiles={setSelectedFiles}
                      isMessageBox={setIsMessageBox}
                    />
                  </Box>
                ) : (
                  <Box sx={{ textAlign: "end", padding: 3 }}>
                    <Button
                      type="submit"
                      sx={{
                        width: "120px",
                        height: "41px",
                        fontSize: "13.3px",
                        fontWeight: 600,
                        color: "#fff",
                        background:
                          "linear-gradient(98.24deg, #2977CC 4.13%, #1D538F 128.24%)",
                      }}
                      onClick={() => setIsMessageBox(true)}
                    >
                      Reply
                    </Button>
                  </Box>
                )}
              </Box>
            ))}

          {/* </Grid2> */}
        </StyledGridBox>
      </Grid2>
    </Box>
  );
};

export default LlcDetail;
const StyledNoteBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "10px",
  background: "#EAF1FA",
  padding: theme.spacing(1),
  borderRadius: "8px",
}));

const StyledNoteText = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: "16px",
  color: "#2977CC",
}));

const StyledNoteSpan = styled("span")(({ theme }) => ({
  fontWeight: 500,
}));
